<div class="main">
    <div class="section">
        <div *ngIf="showLoader" class="loader">
            <div class="load">
              <mat-spinner></mat-spinner>
            </div>
  
          </div>
      <div class="header">
        <div class="title">
          <div class="label">
            {{'TAX.tax' | translate}}
          </div>
          <div class="help">
            <app-help [helpData]="helpData" ></app-help>
          </div>
        </div>
        
      </div>
      <div class="body">
        <div class="left">
          <div class="head">
            <div class="lab">
              {{'TAX.gstDetails' | translate}}
            </div>
          </div>
          <div class="form">
            <div class="inputContainer">
              <div class="label">
                  {{'TAX.taxDetail1' | translate}}
              </div>
              <input type="text" [(ngModel)]="gstVat">
            </div>
            <div class="inputContainer">
                <div class="label">
                    {{'TAX.taxDetail2' | translate}}
                </div>
                <input type="text" [(ngModel)]="panCr">
              </div>
          </div>
          <div class="submitButton">
            <div class="button" (click)="submitGst();">
                {{'TAX.submit' | translate}}
            </div>
          </div>
        </div>
        <div class="right">
            <div class="head">
              <div class="lab">
                {{'TAX.bankDetails' | translate}}
              </div>
              </div>
              <div class="form">
                <div class="inputContainer">
                  <div class="label">
                      {{'TAX.bankDetails1' | translate}}
                  </div>
                  <input type="text" [(ngModel)]="accountNo">
                </div>
                <div class="inputContainer">
                    <div class="label">
                        {{'TAX.bankDetails2' | translate}}
                    </div>
                    <input type="text" [(ngModel)]="branch">
                  </div>
                  <div class="inputContainer">
                      <div class="label">
                          {{'TAX.bankDetails3' | translate}}
                      </div>
                      <input type="text" [(ngModel)]="uniqueNo">
                    </div>
              </div>
              <div class="submitButton">
                <div class="button" (click)="submitBank();">
                    {{'TAX.submit' | translate}}
                </div>
              </div>
        </div>
      </div>
    </div>
  </div>
  